import React from "react";
import {
    ControlLabel,
    FormGroup,
    Button,
} from "react-bootstrap";
import { useEventContext } from "../../../../context";
import PanelTabWrapper from "../PanelTabWrapper";

const Materials = () => {
    const { event } = useEventContext();

    return (
        <PanelTabWrapper title="Материалы">
            <>
                <FormGroup style={{display: 'flex', gap: 10, alignItems: 'center'}}>
                    <ControlLabel>Комментарии</ControlLabel>
                    <Button onClick={() => window.open(`/api/cp/event/${event.eventPassword}/comment/archive.xlsx`)}>
                        Скачать Excel
                    </Button>
                </FormGroup>
                <FormGroup style={{display: 'flex', gap: 10, alignItems: 'center'}}>
                    <ControlLabel>Вопросы</ControlLabel>
                    <Button onClick={() => window.open(`/api/cp/event/${event.eventPassword}/question/archive.xlsx`)}>
                        Скачать Excel
                    </Button>
                </FormGroup>
                <FormGroup style={{display: 'flex', gap: 10, alignItems: 'center'}}>
                    <ControlLabel>Зрители</ControlLabel>
                    <Button onClick={() => window.open(`/api/cp/event/${event.eventPassword}/client.xlsx`)}>
                        Скачать Excel
                    </Button>
                </FormGroup>
            </>
        </PanelTabWrapper>
    );
};

export default Materials;